<template>
  <v-chip small label outlined color="primary">
    <v-icon v-if="icon" class="mr-1" small>{{icon}}</v-icon>
    {{label}} - <strong>{{value}}</strong>
  </v-chip>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ModelVue from "../../ModelVue";

@Component({
  components: {
  },
})
export default class FInfoHighlight extends ModelVue {
 @Prop()
 label: string;

@Prop()
 icon: string;
}
</script>
